import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { getIsStaff } from 'common/state/user';

import PrivateRoute from './PrivateRoute';

const StaffOnly = ({ children }) => {
  const isStaff = useSelector(getIsStaff);
  const location = useLocation();

  return (
    <PrivateRoute>
      {isStaff ? (
        children
      ) : (
        <Navigate to={{ pathname: '/forbidden' }} state={{ from: location }} replace />
      )}
    </PrivateRoute>
  );
};

StaffOnly.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StaffOnly;
